import { Link } from 'react-router-dom';
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function NavMenuContent() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="h-10 w-32 animate-pulse bg-white/5 rounded-md" />;
  }
  return <>
      {/* Desktop Navigation */}
      <nav id="nav" className="hidden md:flex items-center" style={{
      gap: "4px",
      columnGap: "4px",
      rowGap: "4px"
    }}>
        {menuItems.map(item => <Link key={item.id} to={item.href || "#"} className="nav-link">
            {item.label}
          </Link>)}
      </nav>

      {/* Mobile Navigation (Inside Sheet) */}
      <div className="flex flex-col mt-6 md:hidden" style={{
      gap: "4px"
    }}>
        {menuItems.map(item => <Link key={item.id} to={item.href || "#"} className="nav-link" style={{
        display: "block"
      }}>
            {item.label}
          </Link>)}
        <div style={{
        marginTop: "16px"
      }}>
          <button className="cta-btn" style={{
          width: "100%"
        }}>Download Orchid</button>
        </div>
      </div>
    </>;
}
export default function Header() {
  return <header id="header" className="sticky top-0 z-50 w-full" style={{
    backgroundColor: "#0B0B0D",
    borderBottom: "1px solid rgba(255,255,255,0.09)",
    fontFamily: 'Geist, "Hanken Grotesk", system-ui, -apple-system, sans-serif'
  }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&display=swap');
        .nav-link {
          font-size: 0.93rem;
          color: #b9b9bd;
          padding: 8px 13px;
          border-radius: 8px;
          transition: color 120ms, background 120ms;
          letter-spacing: -0.01em;
          text-decoration: none;
          font-weight: 400;
        }
        .nav-link:hover {
          color: #f4f4f3;
          background: rgba(255, 255, 255, 0.05);
        }
        .nav-link.active {
          color: #f4f4f3;
        }
        .cta-btn {
          background: #F5C518;
          color: #1A1500;
          font-weight: 700;
          font-size: 0.93rem;
          border-radius: 10px;
          padding: 10px 20px;
          border: none;
          cursor: pointer;
          letter-spacing: -0.01em;
          transition: background 150ms;
          white-space: nowrap;
        }
        .cta-btn:hover {
          background: #FFD84A;
        }
      `}</style>

      <div className="page-container">
        <div className="flex items-center justify-between" style={{
        height: "56px"
      }}>
          <Link to="/" className="flex items-center no-underline" style={{
          gap: "6px",
          textDecoration: "none"
        }}>
            <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg" style={{
            flexShrink: 0
          }}>
              <rect x="0" y="0" width="8" height="6" rx="1" fill="#76767d" />
              <rect x="10" y="0" width="8" height="6" rx="1" fill="#F5C518" />
              <rect x="0" y="8" width="8" height="6" rx="1" fill="#F5C518" />
              <rect x="10" y="8" width="8" height="6" rx="1" fill="#76767d" />
            </svg>
            <span style={{
            fontSize: "15px",
            fontWeight: 600,
            color: "#F4F4F3",
            letterSpacing: "-0.01em",
            fontFamily: 'Geist, "Hanken Grotesk", system-ui, -apple-system, sans-serif'
          }}>
              temative
            </span>
          </Link>

          <MenuProvider menu_id="16">
            <NavMenuContent />
          </MenuProvider>

          <div className="hidden md:flex items-center">
            <button className="cta-btn">Download Orchid</button>
          </div>

          <Sheet>
            <SheetTrigger asChild>
              <button className="md:hidden flex flex-col justify-center items-center gap-1" style={{
              background: "transparent",
              border: "none",
              cursor: "pointer",
              padding: "8px"
            }} aria-label="Open menu">
                <span style={{
                display: "block",
                width: "20px",
                height: "2px",
                background: "#F4F4F3",
                borderRadius: "2px"
              }} />
                <span style={{
                display: "block",
                width: "20px",
                height: "2px",
                background: "#F4F4F3",
                borderRadius: "2px"
              }} />
                <span style={{
                display: "block",
                width: "20px",
                height: "2px",
                background: "#F4F4F3",
                borderRadius: "2px"
              }} />
              </button>
            </SheetTrigger>
            <SheetContent side="right" style={{
            backgroundColor: "#0B0B0D",
            borderLeft: "1px solid rgba(255,255,255,0.09)"
          }}>
              <SheetHeader>
                <SheetTitle style={{
                color: "#F4F4F3",
                fontFamily: 'Geist, "Hanken Grotesk", system-ui, sans-serif'
              }}>
                  temative
                </SheetTitle>
              </SheetHeader>
              <MenuProvider menu_id="16">
                <NavMenuContent />
              </MenuProvider>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>;
}